import { get, flow, isEmpty, pick, values, isEqual } from 'lodash/fp';
import { createStructuredSelector, createSelector } from 'reselect';

import {
  MERCHANT,
  RETAIL,
  PRIVATE_SALE,
  PRIVATE_LISTING_SELLER,
} from 'helpers/fieldOptions/ad/sellerType';
import { names as equipmentNames } from 'helpers/fieldOptions/car/equipments';
import {
  VEHICLE_NAME,
  MAKE_NAME,
  FUEL_TYPE_NAME,
  GEOLOCATION_NAME,
  MILEAGE_RANGE_NAME,
  PRICE_RANGE_NAME,
  SELLER_TYPE_NAME,
  TRANSMISSION_NAME,
  YEAR_RANGE_NAME,
  MONTHLY_PRICE_RANGE_NAME,
} from '../../../../constants';

const getMin = get(['min']);
const getMax = get(['max']);

const getEquipments = pick(values(equipmentNames));

const isAllSellerTypes = isEqual([
  MERCHANT,
  RETAIL,
  PRIVATE_SALE,
  PRIVATE_LISTING_SELLER,
]);

const getInitialOpened = createSelector(
  flow(
    get(['initialForm']),
    createStructuredSelector({
      make: get([VEHICLE_NAME, 0, MAKE_NAME]),
      fuelType: get([FUEL_TYPE_NAME]),
      equipments: getEquipments,
      location: get([GEOLOCATION_NAME]),
      priceRange: get([PRICE_RANGE_NAME]),
      monthlyPriceRange: get([MONTHLY_PRICE_RANGE_NAME]),
      yearRange: get([YEAR_RANGE_NAME]),
      mileageRange: get([MILEAGE_RANGE_NAME]),
      sellerType: get([SELLER_TYPE_NAME]),
      transmission: get([TRANSMISSION_NAME]),
    }),
  ),
  get(['initialOpened']),
  flow(
    (
      {
        make,
        fuelType,
        equipments,
        location,
        priceRange,
        monthlyPriceRange,
        yearRange,
        mileageRange,
        sellerType,
        transmission,
      } = {},
      initialOpened = {},
    ) => ({
      location: !isEmpty(location),
      equipments: !isEmpty(equipments),
      fuelType: !!fuelType,
      makes: !!make || !!initialOpened.makes,
      price: !!getMin(priceRange) || !!getMax(priceRange),
      monthlyPrice: !!getMin(monthlyPriceRange) || !!getMax(monthlyPriceRange),
      mileage: !!getMin(mileageRange) || !!getMax(mileageRange),
      sellerType: !isAllSellerTypes(sellerType),
      transmission: !!transmission,
      year: !!getMin(yearRange) || !!getMax(yearRange),
    }),
  ),
);

export default {
  initialOpened: getInitialOpened,
};
